"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedInlineTableField = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const inline_table_field_1 = require("../inline-table-field/inline-table-field");
function NestedInlineTableField({ nestedPath, nestedColumns, columns: directColumns, ...props }) {
    const columns = react_1.useMemo(() => lodash_1.compact([
        ...directColumns,
        ...nestedColumns.map((column) => ({
            ...column,
            datakey: `${nestedPath}.${column.datakey}`,
        })),
    ]), [directColumns, nestedColumns, nestedPath]);
    return react_1.default.createElement(inline_table_field_1.InlineTableField, Object.assign({}, props, { columns: columns }));
}
exports.NestedInlineTableField = NestedInlineTableField;
//# sourceMappingURL=nested-inline-table-field.js.map